var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.33333C4.2 -0.777778 13.8 -0.777778 17 6.33333",
    stroke: "#0F2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99479 9.88888C8.6446 9.88888 8.29784 9.8199 7.9743 9.68589C7.65077 9.55188 7.3568 9.35545 7.10917 9.10783C6.86155 8.8602 6.66513 8.56623 6.53111 8.2427C6.3971 7.91916 6.32812 7.5724 6.32812 7.22221C6.32812 6.87202 6.3971 6.52525 6.53111 6.20172C6.66513 5.87818 6.86155 5.58421 7.10917 5.33659C7.3568 5.08897 7.65077 4.89254 7.9743 4.75853C8.29784 4.62452 8.6446 4.55554 8.99479 4.55554C9.70204 4.55554 10.3803 4.83649 10.8804 5.33659C11.3805 5.83669 11.6615 6.51496 11.6615 7.22221C11.6615 7.92945 11.3805 8.60773 10.8804 9.10783C10.3803 9.60792 9.70204 9.88888 8.99479 9.88888Z",
    fill: "#0F2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEye);
export default __webpack_public_path__ + "static/media/viewEye.19b68961c433aeca889aa5484848b56a.svg";
export { ForwardRef as ReactComponent };